<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gamePrefix.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gamePrefix.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('add_new')
            }}
          </ts-button>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.prefix }}</td>
          <td>{{ record.sequence_digit }}</td>
          <td>{{ record.yyyy }}</td>

          <td class="text-center">
            <i class="fas fa-check ts-text-blue-600" v-if="record.mm"></i>
            <i class="fas fa-times ts-text-red-600" v-else></i>
          </td>
          <td>{{ record.prefix_sample }}</td>
          <td class="text-center">
            <div v-if="!record.draw_setting_count">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i class="fas fa-circle-notch spin ml-2" v-if="record._deleting"></i>
                  <i class="fa fa-trash ml-2 text-red" v-else></i>
                </a>
              </a-popconfirm>
            </div>
            <div v-else>
              <span
                class="ts-bg-gray-500 ts-px-2 ts-rounded-md ts-font-semibold ts-whitespace-no-wrap"
              >{{ $t('gamePrefix.inUse') }}</span>
            </div>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <!-- form create or update -->
    <a-modal
      :title="isEdit ? $t('update') : $t('create')"
      v-if="show_form"
      v-model="show_form"
      width="400px"
      :footer="null"
      :maskClosable="false"
      @cancel="cancel"
      :zIndex="1020"
    >
      <form-component @close="cancel" />
    </a-modal>
  </div>
</template>

<script>
import FormComponent from './form'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'gamePrefix',
  components: {
    FormComponent
  },
  data() {
    return {
      loading: false,
      show_form: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/gamePrefix', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.gamePrefix.search
      },
      set(newValue) {
        this.$store.commit('administrator/gamePrefix/SET_SEARCH', newValue)
        this.$store.commit('administrator/gamePrefix/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('gamePrefix.prefix') },
        { name: this.$t('gamePrefix.digit') },
        { name: this.$t('gamePrefix.year') },
        {
          name: this.$t('gamePrefix.includeMonth'),
          style: 'text-align:center'
        },
        { name: this.$t('gamePrefix.sample') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    },
    isEdit() {
      return !_.isEmpty(this.$store.state.administrator.gamePrefix.edit_data)
    }
  },
  methods: {
    ...mapActions('administrator/gamePrefix', ['destroy']),
    addNew() {
      this.show_form = true
    },
    cancel() {
      this.show_form = false
      this.fetchData()
      this.$store.commit('administrator/gamePrefix/SET_EDIT_DATA', {})
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/gamePrefix/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('administrator/gamePrefix/SET_EDIT_DATA', record)
      this.show_form = true
    },
    deleteRecord(record) {
      record._deleting = true
      this.destroy(record.prefix_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/gamePrefix/RESET_STATE')
    next()
  }
}
</script>